import React from "react";
import { Container, Image } from "react-bootstrap";
import { networkID } from '../../static/utils';
import { connectWallet } from '../../static/walletUtils';

const Warnings = ({ net }) => (
  <div className="preloader" id="preloader">
    <Container fluid className="justify-content center text-center">
      <Image
        src={require("../../static/Images/warning.png")}
        className="warning-logo"
      />
      <h2 className="text-center warning-text my-3 mb-5">
        {net
          ? `Please Connect to Main net (Network Id ${networkID})`
          : "Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!"}{" "}
      </h2>
      <div
        onClick={() => {
          connectWallet();
        }}
        className=" mybtn1 warningbtn"
      >
        {net ? "Switch" : "Connect"}
      </div>
    </Container>
  </div>
);

export default Warnings;
